import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RootThemeProvider } from "./theme";
import AppRoutes from "./routes";

export default function App() {
    return (
        <RootThemeProvider>
            <BrowserRouter>
                <AppRoutes />
                <ToastContainer
                    position="bottom-right"
                    autoClose={3500}
                    hideProgressBar
                    newestOnTop
                    closeOnClick
                    theme="colored"
                    toastStyle={{
                        borderRadius: 3,
                        fontFamily:
                            "'Hanken Grotesk', 'Helvetica Neue', Arial, sans-serif",
                    }}
                />
            </BrowserRouter>
        </RootThemeProvider>
    );
}
